import { render, staticRenderFns } from "./forgetpassword.vue?vue&type=template&id=21f1bec8&scoped=true&lang=pug"
import script from "./forgetpassword.vue?vue&type=script&lang=js"
export * from "./forgetpassword.vue?vue&type=script&lang=js"
import style0 from "./forgetpassword.vue?vue&type=style&index=0&id=21f1bec8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f1bec8",
  null
  
)

export default component.exports